import React from 'react';
import colors from 'shared-components/theme/colors';
import styled from 'styled-components';
import IntroductionTitle from './introduction-title';
import Media from 'shared-components/theme/medias';
import { gilroyMedium } from 'shared-components/theme/fonts';
const LetsBuild = ({ text, btnTxt, textColor, btnColor, btnBg, href }) => {
    return (
        <Wrap>
            <IntroductionTitle title={text} textColor={textColor} />
            <Btn href={href} btnColor={btnColor} btnBg={btnBg}>
                {btnTxt}
            </Btn>
        </Wrap>
    );
};

export default LetsBuild;

const Wrap = styled.section`
    background: ${colors.geoGreen[100]};
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    position: relative;
    z-index: 2;
    h2 {
        text-align: center;
    }
`;
const Btn = styled.a`
    max-width: 220px;
    width: 100%;
    height: 62px;
    border-radius: 10px;
    font-size: 18px;
    color: ${(props) => props.btnColor || colors.geoGreen[100]};
    background-color: ${(props) => props.btnBg || colors.geoGreen[50]};
    font-family: ${gilroyMedium};
    font-weight: 500;
    text-align: center;
    line-height: 62px;
    text-transform: uppercase;
    transition: 0.3s ease;
    border: 1px solid transparent;
    &:hover {
        background: ${colors.geoGreen[90]};
        border: 1px solid ${colors.geoGreen[50]};
        color: ${colors.geoWhite[100]};
    }
    ${Media('large')} {
        max-width: 13.813vw;
        height: 4vw;
        line-height: 4vw;
        font-size: 1.19vw;
    }

    ${Media('tabletlandscape')} {
        max-width: 180px;
        height: 52px;
        line-height: 52px;
        font-size: 16px;
    }

    ${Media('mobile')} {
        max-width: 140px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }
`;
